import React from 'react';

import { Divider, Stack, Text, useToast } from '@adc/parallax-component-library';
import { IconValidationValid } from '@adc/parallax-icons';

import { useConnection } from 'Hooks';

import { Link } from 'Components/utility';

import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';

import { removeInvitation } from 'Services/llu';

type Props = {
  connection: Connection;
};

const PendingDetails: React.FC<Props> = ({ connection }) => {
  const { showToast } = useToast();
  const { showRemoveInvitationModal } = useConnection();

  const onResendInvitation = () => {
    showToast({
      message: i18n.t('Connections.modals.connectionInvitedToast.body'),
      'aria-label': i18n.t('Connections.modals.connectionInvitedToast.body'),
      icon: <IconValidationValid color="$support.positive.default" />,
    });
  };

  const onRemoveInvitation = async () => {
    showRemoveInvitationModal(async () => {
      try {
        await removeInvitation(connection.ConnectionID);
        mediator.publish('router:navigate', '/connections');
      } catch (error) {
        log.error(error);
      }
    });
  };

  return (
    <Stack margin="$4" padding="$4" backgroundColor="$surface.container" border="1.5" shadow="$-1">
      <Text
        testID="PendingConnection.title"
        color="$text.100"
        fontWeight="$h3.strong"
        fontSize="$h3.strong"
      >
        {i18n.t('Connections.content.pendingConnection.primaryText')}
      </Text>
      <Text
        testID="PendingConnection.bodyText"
        marginTop="$2"
        color="$text.100"
        fontWeight="$bodyBase.default"
        fontSize="$bodyBase.default"
      >
        {i18n.t('Connections.content.pendingConnection.bodyText')}
      </Text>
      <Text
        testID="PendingConnection.email-label"
        marginTop="$8"
        color="$text.60"
        fontWeight="$bodySmall.default"
        fontSize="$bodySmall.default"
      >
        {i18n.t('Connections.content.pendingConnection.secondaryText')}
      </Text>
      <Text
        testID="PendingConnection.email"
        color="$text.100"
        fontWeight="$bodyBase.medium"
        fontSize="$bodyBase.medium"
      >
        {connection.CaregiverEmail}
      </Text>
      <Divider marginVertical="$4" borderColor="$neutral.40" />
      <Link
        testID="PendingConnection.resendInvitation-btn"
        onPress={onResendInvitation}
        style={{ marginBottom: 32 }}
      >
        {i18n.t<string>('Connections.content.pendingConnection.links.resendInvitation.label')}
      </Link>
      <Link
        testID="PendingConnection.remove-btn"
        onPress={onRemoveInvitation}
        textColor="$support.danger.default"
      >
        {i18n.t<string>('Global.microcopy.common.removeCap')}
      </Link>
    </Stack>
  );
};

export default PendingDetails;
